export const compareFilter = (categoryId, prevCategoryId, nrTitle, prevNrTitle) => {
	return (categoryId || null) === (prevCategoryId || null)
		&& (nrTitle || null) === (prevNrTitle || null)
}
